var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalTabActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4717",
    "data-name": "Group 4717",
    transform: "translate(21140 14592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-ipad-1497748",
    transform: "translate(-21109.867 -14565.4) rotate(-180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13086",
    "data-name": "Path 13086",
    d: "M26.5,0H1.767A1.772,1.772,0,0,0,0,1.767V19.433A1.772,1.772,0,0,0,1.767,21.2H26.5a1.772,1.772,0,0,0,1.767-1.767V1.767A1.772,1.772,0,0,0,26.5,0Zm.883,19.433a.886.886,0,0,1-.883.883H1.767a.886.886,0,0,1-.883-.883V1.767A.886.886,0,0,1,1.767.883H26.5a.886.886,0,0,1,.883.883Z",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13087",
    "data-name": "Path 13087",
    d: "M1.325,0A1.325,1.325,0,1,0,2.65,1.325,1.329,1.329,0,0,0,1.325,0Zm0,2.208a.883.883,0,1,1,.883-.883A.886.886,0,0,1,1.325,2.208Z",
    transform: "translate(1.767 9.054)",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 0.473,
    cy: 0.473,
    r: 0.473,
    transform: "translate(25.426 10.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13088",
    "data-name": "Path 13088",
    d: "M18.991,0H.442A.443.443,0,0,0,0,.442V17.224a.443.443,0,0,0,.442.442H18.991a.443.443,0,0,0,.442-.442V.442A.443.443,0,0,0,18.991,0Zm0,17.224H.442V.442H18.991Z",
    transform: "translate(5.3 1.767)",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 32,
    height: 32,
    transform: "translate(-21140 -14592)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalTabActive);
export default __webpack_public_path__ + "static/media/horizontal-tab-active.e48fb4371e8a2c03da2fa81c99e063b1.svg";
export { ForwardRef as ReactComponent };